import {Voluntier} from "../lib/types/voluntiers";

export const getAmountOfRequests = (volontierRequests: Voluntier[]) => {
	return volontierRequests.filter(volontier => volontier.status === "pending").length;
}
